import { NgModule } from "@angular/core";
import { DateTimePipe } from "./date-time.pipe";
import { StringFromListPipe } from "./string-from-list.pipe";
import { TruncatePipe } from "./truncate.pipe";
import { CapitalizePipe } from "./capitalize.pipe";

@NgModule({
    declarations: [
        DateTimePipe,
        StringFromListPipe,
        TruncatePipe,
        CapitalizePipe
    ],
    exports: [
        DateTimePipe,
        StringFromListPipe,
        TruncatePipe,
        CapitalizePipe
    ]
})
export class MayaCommonUtilsModule { }
  